import { NgModule } from '@angular/core';
import { MediaLoadDirective } from './media-load.directive';

@NgModule({
  declarations: [
    MediaLoadDirective,
  ],
  exports: [
    MediaLoadDirective,
  ],
})
export class ResourceDirectivesModule {}
